module.exports = __webpack_public_path__ + "fonts/CircularStd-Bold.bd1f8d24.woff2";